import { useState } from "react";
import TextField from "@mui/material/TextField";
import axios from "axios";
import { url } from "../../../App";

const ForgotPassword = () => {
  //eslint-disable-next-line
  const [authToken, setAuthToken] = useState("");
  const [inputFields, setInputFields] = useState({
    email: "",
    otp: "",
  });
  const inputFieldHandler = (e, field) => {
    setInputFields((prevState) => ({
      ...prevState,
      [field]: e.target.value,
    }));
  };
  const sendOtpHandler = async () => {
    try {
      const { data: tokenData } = await axios.post(url + "/user/lmslogin", {
        email: "borrowerapp@credin.in",
        password: "Credin@123",
      });
      console.log(tokenData);
      setAuthToken(tokenData?.token);
      const sendOtpReq = {
        email: inputFields.email,
        token: tokenData?.token,
      };
      const { data: sendOtpRes } = await axios.post(
        url + "/user/otpsend",
        sendOtpReq
      );
      console.log(sendOtpRes, sendOtpReq);
    } catch (err) {
      console.error(err);
      return null;
    }
  };
  const verifyOtpHandler = async () => {
    try {
      const tokenReq = {
        email: "test.lm@credin.in",
        password: "Test!@lms",
      };
      const tokenRes = await axios.post(
        "http://staging.console.api.credin.in/api/auth/login",
        tokenReq
      );
      console.log(tokenRes);
    } catch (err) {
      console.error(err);
      return null;
    }
    try {
    } catch (err) {}
  };
  return (
    <>
      <div className="input-item-login">
        <label className="label-login">Username or Email</label>
        <br />
        <TextField
          className="input-field-login"
          variant="outlined"
          value={inputFields.email}
          required
          name="email"
          onChange={(e) => inputFieldHandler(e, "email")}
          style={{ backgroundColor: "#F0F4F7", width: "30ch" }}
          size="small"
        />
        <div className="sendOtp" onClick={sendOtpHandler}>
          Send OTP
        </div>
      </div>
      <div className="input-item-login">
        <label className="label-login">OTP</label>
        <br />
        <TextField
          className="input-field-login"
          variant="outlined"
          required
          name="otp"
          value={inputFields.otp}
          onChange={(e) => inputFieldHandler(e, "otp")}
          style={{ backgroundColor: "#F0F4F7", width: "30ch" }}
          size="small"
        />
      </div>
      <button className="btn-submit-login" onClick={verifyOtpHandler}>
        Verify OTP
      </button>
    </>
  );
};

export default ForgotPassword;
